import * as styles from "./MeterValue.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Meter as BaseMeter } from "@base-ui/react/meter";

import type { MeterValueProps } from "./Meter.types";

export function MeterValue({
  className,
  ...props
}: MeterValueProps): JSX.Element {
  return (
    <BaseMeter.Value
      data-slot="meter-value"
      className={clsx(styles.value, className)}
      {...props}
    />
  );
}
